var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg26(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_2993)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1_2993)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32 6H14C11.7909 6 10 7.79086 10 10V28C10 30.2091 11.7909 32 14 32H32C34.2091 32 36 30.2091 36 28V10C36 7.79086 34.2091 6 32 6Z",
    fill: "#A92C2C"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M32 2H14C11.7909 2 10 3.79086 10 6V24C10 26.2091 11.7909 28 14 28H32C34.2091 28 36 26.2091 36 24V6C36 3.79086 34.2091 2 32 2Z",
    fill: "#F13838"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.0791 18.86C17.0791 18.11 17.1991 17.47 17.4391 16.94C17.6791 16.4 18.1091 15.805 18.7291 15.155C19.3391 14.505 19.7591 13.95 19.9891 13.49C20.2291 13.03 20.3491 12.55 20.3491 12.05C20.3491 11.6 20.2741 11.29 20.1241 11.12C19.9841 10.94 19.7741 10.85 19.4941 10.85C18.9241 10.85 18.6391 11.195 18.6391 11.885V13.01H17.0791V11.99C17.0791 11.14 17.2891 10.49 17.7091 10.04C18.1291 9.58 18.7391 9.35 19.5391 9.35C20.3391 9.35 20.9491 9.58 21.3691 10.04C21.7891 10.49 21.9991 11.14 21.9991 11.99C21.9991 12.63 21.8441 13.255 21.5341 13.865C21.2341 14.475 20.7091 15.175 19.9591 15.965C19.4691 16.485 19.1391 16.91 18.9691 17.24C18.7991 17.56 18.7141 17.905 18.7141 18.275V18.5H21.8491V20H17.0791V18.86ZM25.545 20.15C24.735 20.15 24.115 19.92 23.685 19.46C23.255 19 23.04 18.35 23.04 17.51V12.08C23.04 10.26 23.88 9.35 25.56 9.35C26.36 9.35 26.97 9.58 27.39 10.04C27.81 10.49 28.02 11.14 28.02 11.99V12.185H26.46V11.885C26.46 11.195 26.175 10.85 25.605 10.85C25.295 10.85 25.065 10.945 24.915 11.135C24.765 11.325 24.69 11.66 24.69 12.14V14.15H24.72C25.01 13.54 25.51 13.235 26.22 13.235C26.82 13.235 27.275 13.44 27.585 13.85C27.895 14.26 28.05 14.855 28.05 15.635V17.51C28.05 18.35 27.835 19 27.405 19.46C26.975 19.92 26.355 20.15 25.545 20.15ZM25.545 18.65C26.115 18.65 26.4 18.31 26.4 17.63V15.77C26.4 15.08 26.115 14.735 25.545 14.735C24.975 14.735 24.69 15.08 24.69 15.77V17.63C24.69 18.31 24.975 18.65 25.545 18.65Z",
    fill: "#111820"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1_2993",
    x: 0,
    y: 0,
    width: 46,
    height: 46,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1_2993"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1_2993",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_2993"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 46,
    height: 46,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg26);
export default __webpack_public_path__ + "static/media/26.1e5418bb28df9b37b8bc85cbb6fb3028.svg";
export { ForwardRef as ReactComponent };